import React, { FC, useContext } from 'react'
import { Radio, Segmented, Switch } from 'antd'
import { BlueConicConfigurationDispatchContext } from '../configuration/reducer'
import { ProductsFilters } from './enums'
import { FormLayoutRow } from '../../../../../../components/form-layout-row/form-layout-row'
import './styles/blueconic-product-filters.scss'
import { EditableViewContext } from '@pushly/aqe/lib/components/hoc/editable-view/editable-view-context'

type BlueConicProductFiltersBuilderProps = {
    filters: ProductsFilters[]
}

export const BlueConicProductFiltersBuilder: FC<BlueConicProductFiltersBuilderProps> = ({ filters }) => {
    const dispatch = useContext(BlueConicConfigurationDispatchContext)

    const viewed = filters.find((f) => [ProductsFilters.VIEWED, ProductsFilters.VIEWED_ONLY].includes(f))
    const carted = filters.find((f) => [ProductsFilters.SHOPPINGCART, ProductsFilters.SHOPPINGCART_ONLY].includes(f))
    const bought = filters.find((f) => [ProductsFilters.BOUGHT, ProductsFilters.BOUGHT_ONLY].includes(f))
    const inStock = filters.find((f) => f === ProductsFilters.IN_STOCK)

    return (
        <div className="blueconic-product-filters">
            {/*<div className="blueconic-product-filters-description">*/}
            {/*    Choose whether to exclude these items from recommendations or send only these items. ‘Exclude’ removes them entirely; ‘Include Only’ limits recommendations to this type.*/}
            {/*</div>*/}
            <ProductFilterRow
                label="Seen Products"
                value={viewed}
                types={[ProductsFilters.VIEWED, ProductsFilters.VIEWED_ONLY]}
            />
            <ProductFilterRow
                label="Carted Products"
                value={carted}
                types={[ProductsFilters.SHOPPINGCART, ProductsFilters.SHOPPINGCART_ONLY]}
            />
            <ProductFilterRow
                label="Bought Products"
                value={bought}
                types={[ProductsFilters.BOUGHT, ProductsFilters.BOUGHT_ONLY]}
            />
            <div className="product-filter-row hide-out-of-stock-products-toggle">
                <label>
                    <Switch
                        onChange={(v) => {
                            dispatch({
                                type: v ? 'update-filter' : 'remove-filter',
                                filterType: 'products',
                                filter: ProductsFilters.IN_STOCK,
                            })
                        }}
                        checked={!!inStock}
                        size="small"
                    />
                    <span className="label-with-component-l">Hide out of stock products</span>
                </label>
            </div>
            <div className="blueconic-product-filters-description">
                Choose whether to exclude these items from recommendations or send only these items. ‘Exclude’ removes
                them entirely; ‘Include Only’ limits recommendations to this type.
            </div>
        </div>
    )
}

type ProductFilterRowProps = {
    label: string
    value: ProductsFilters | undefined
    types: ProductsFilters[]
}

const ProductFilterRow: FC<ProductFilterRowProps> = ({ label, value, types }) => {
    const ctxView = useContext(EditableViewContext)
    const dispatch = useContext(BlueConicConfigurationDispatchContext)

    const options = types.map((type) => {
        return {
            label: type.includes('ONLY') ? 'Include Only' : 'Exclude',
            value: type,
        }
    })

    const hideOption = types.find((t) => !t.includes('ONLY'))!
    const showOption = types.find((t) => t.includes('ONLY'))!

    const [localValue, setLocalValue] = React.useState<ProductsFilters | undefined>(value)

    return (
        <div className="product-filter-row">
            <div className="filter-row-toggle">
                <label className={ctxView.modeClassName}>
                    <Switch
                        size="small"
                        checked={!!value}
                        onChange={(v) => {
                            dispatch({
                                type: v ? 'update-filter' : 'remove-filter',
                                filterType: 'products',
                                filter: localValue ?? hideOption,
                            })
                        }}
                    />
                    <span className="label-with-component-l">{label}</span>
                </label>
            </div>
            <div className="filter-row-hide-show">
                <Segmented
                    className={ctxView.modeClassName}
                    value={value}
                    disabled={!value}
                    defaultValue={hideOption}
                    size="small"
                    onChange={(v: ProductsFilters) => {
                        setLocalValue(v)
                        dispatch({
                            type: 'remove-filter',
                            filterType: 'products',
                            filter: v === hideOption ? showOption : hideOption,
                        })
                        dispatch({ type: 'update-filter', filterType: 'products', filter: v })
                    }}
                    options={options.map((option) => ({
                        value: option.value,
                        label: option.label,
                    }))}
                />
            </div>
        </div>
    )
}
